import React from 'react';
import './BurgerMenu.css';
import { Link } from 'react-router-dom';





function BurgerMenu({ isOpen }) {

  return (
    <>
      <div className='hamburger'>
        <div className='burger burger1' />
        <div className='burger burger2' />
        <div className='burger burger3' />
      </div>

      <ul className='burger-links'>
        <Link to='/'>Home</Link>
        <Link to='/players'>Players</Link>
        <Link to='/myPlayers'>My Players</Link>
        <Link to='/myTeam'>My Team</Link>
      </ul>

      <style jsx>{`
            .burger1 {
                transform: ${isOpen ? "rotate(45deg)" : "rotate(0)"};
              }
              .burger2 {
                transform: ${isOpen ? "translateX(100%)" : "translateX(0)"};
                opacity: ${isOpen ? 0 : 1};
              }
              .burger3 {
                transform: ${isOpen ? "rotate(-45deg)" : "rotate(0)"};
              }
              .burger-links {
              display: ${isOpen ? 'grid' : 'none'}
          }
        
          `}</style>


    </>

  )
}
export default BurgerMenu;
